<template>

    <ul
            :style="{ backgroundImage: 'url(' + require('@/assets/' + langSelect + '.png') + ')' }"
            :class="langShow ? 'active' : ''"
            @click="changelang"
    >
        <li
                v-for="(lang) in $ml.list"
                :key="lang"
                @click="$ml.change(lang)"
                v-text="lang"
                :class="langSelect == lang ? 'active-li' : ''"
                :style="{
                backgroundImage: 'url(' + require('@/assets/' + lang + '.png') + ')'
              }"
        />
    </ul>

</template>

<script>
    import {mapActions, mapMutations, mapState} from 'vuex';
    import logAnalyticsEvent from '@/helpers/analytics'

    export default {
        name: 'languageSwitcher',

        data() {
            return {
                langShow: false,
                langSelect: this.$ml.current,
            }
        },

        mounted() {
            this.setLanguage(this.$ml.current)
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo
            })
        },
        methods: {
            ...mapMutations({
                setLanguage: 'setLanguage'
            }),
            ...mapActions({
                updateProfileLang: 'profiles/updateProfileLang',
            }),
            changelang() {
                logAnalyticsEvent('lang_click', {
                    lang: this.$ml.current,
                    source: this.$route.name === 'Login' ? 'sign_in' : 'drawer'
                })
                this.langShow = !this.langShow
                this.langSelect = this.$ml.current;
                this.setLanguage(this.$ml.current)
                this.updateLanguage()
            },

            async updateLanguage() {
                const response = await this.updateProfileLang(localStorage.getItem('lang'))
            },
            
        },

    }
</script>

<style scoped>
    .lang-dropdown {
        display: none;
    }
    .change_language ul,
    .change_language li {
        background-size: contain;
        background-position: center;
        height: 2em;
        width: 2em;
        cursor: pointer;
    }

    .change_language ul {
        position: fixed;
        bottom: 1em;
        left: 1em;
        margin: 0;
        z-index: 99;
    }

    .change_language.absolute ul {
        position: absolute;
        bottom: 0;
    }

    .change_language li {
        text-transform: capitalize;
        position: absolute;
        margin: 0;
        transition: all .5s ease-in-out;
        color: transparent;
    }

    .change_language li:first-child {
        left: 3em;
    }

    .change_language li:nth-child(2) {
        bottom: 3em;
        left: 3em;
    }

    .change_language li:nth-child(3) {
        bottom: 6em;
        left: 3em;
    }

    .change_language li:nth-child(4) {
        bottom: 9em;
        left: 3em;
    }

    .change_language li:nth-child(5) {
        bottom: 12em;
        left: 3em;
    }

    .change_language li:nth-child(6) {
        bottom: 15em;
        left: 3em;
    }

    .change_language li:nth-child(7) {
        bottom: 18em;
        left: 3em;
    }

    .change_language ul:not(.active) li {
        left: -5em !important;
    }

    .bm-menu ul {
        display: flex;
        flex-direction: column;
        text-align: left;
        background: none !important;
        padding-left: 0;
    }

    .bm-menu ul,
    .bm-menu ul li {
        background-size: contain;
        background-repeat: no-repeat;
        text-transform: capitalize;
        margin: 0;
    }

    .bm-menu ul li {
        height: 30px;
        width: 30px;
        font-size: 0;
        margin-right: 15px;
    }

</style>
